import React from 'react';
import { Box, Grid2 } from '@mui/material';
import CustomDialog from '../../../../../../shared_lib/src/shared/lib/ui-components/Dialog/CustomDialog';
import CustomDialogActions from '../../../../../../shared_lib/src/shared/lib/ui-components/Dialog/CustomDialogActions';
import CustomDialogContent from '../../../../../../shared_lib/src/shared/lib/ui-components/Dialog/CustomDialogContent';
import CustomTypography from '../../../../../../shared_lib/src/shared/lib/ui-components/Typography/CustomTypography';
import CustomButton from '../../../../../../shared_lib/src/shared/lib/ui-components/Button/CustomButton';

export interface ConfirmationPopupProps {
  openPopup: boolean;
  onClosePopup: () => void;
  title: string;
  message: string;
  onConfirm: () => void;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  openPopup,
  onClosePopup,
  title,
  message,
  onConfirm,
}) => {
  return (
    <Box>
      <CustomDialog
        id="confirmation-dialog"
        open={openPopup}
        onClose={(reason: string) => {
          if (reason === 'backdropClick') {
            return;
          }
          onClosePopup();
        }}
        disableEscapeKeyDown={true}
      >
        <CustomDialogContent className="dialog-width">
          <Box className="pb-6">
            <CustomTypography id="confirmation-title-popup" variant="subtitle1">
              {title}
            </CustomTypography>
          </Box>
          <Box>
            <CustomTypography id="confirmation-title-popup" variant="body3">
              {message}
            </CustomTypography>
          </Box>
        </CustomDialogContent>

        <CustomDialogActions>
          <Grid2 container>
            <Grid2 className="mr-8">
              <CustomButton
                id="btnYes"
                color="error"
                variant="outlined"
                onClick={() => {
                  onClosePopup();
                }}
              >
                Cancel
              </CustomButton>
            </Grid2>
            <Grid2>
              <CustomButton
                id="confirmation-confirm"
                color="primary"
                variant="contained"
                onClick={() => {
                  onConfirm();
                }}
              >
                {'Confirm'}
              </CustomButton>
            </Grid2>
          </Grid2>
        </CustomDialogActions>
      </CustomDialog>
    </Box>
  );
};

export default ConfirmationPopup;
